import { render, staticRenderFns } from "./my-dialog.vue?vue&type=template&id=5ea9e179&scoped=true&"
import script from "./my-dialog.vue?vue&type=script&lang=js&"
export * from "./my-dialog.vue?vue&type=script&lang=js&"
import style0 from "./my-dialog.vue?vue&type=style&index=0&id=5ea9e179&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9e179",
  null
  
)

export default component.exports